export function pushEventGTM(eventObject: Record<string, unknown>): void {
  // syntax `'dataLayer' in window doesn't work in 2.4.2
  if (window.dataLayer) {
    window.dataLayer.push(eventObject);
  }
}
